// src/publicuser/components/learning/CommentSection.jsx
import React, { useState, useEffect } from 'react';
import '../../css/CommentSection.css';
import {commentService} from '../../../services/commentService'
 import { isAuthenticated } from '../../../utils/auth';
import { useLocation, useNavigate } from "react-router-dom";

const CommentSection = ({ postId }) => {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [newComment, setNewComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loggedIn = isAuthenticated();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLoginClick  = () => {
    navigate("/login", {
      state: {
        from: location.pathname
      }
    });
  };



  useEffect(() => {
    if (postId) {
      loadComments();
    }
  }, [postId]);

  const loadComments = async () => {
    setIsLoading(true);
    try {
      const response = await commentService.getCommentsByPostId(postId);
      const commentsData = response.data || [];
      setComments(commentsData);
    } catch (error) {
      console.error('Failed to load comments:', error);
      setComments([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitComment = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    
    setIsSubmitting(true);
    try {


   const commentData = {
        Content: newComment,
        PostId: postId,
        UserId: "",    
      };
 
      const addedComment = await commentService.create(commentData);
      if(addedComment.data)
      {
        setComments(prev => [addedComment.data, ...prev]);
      }
        setNewComment('');
    } catch (error) {
      console.error('Failed to add comment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

const formatDate = (dateString) => {
  if (!dateString) return 'Recent';

  const date = new Date(dateString);
  const now = new Date();

  // convert to UTC timestamps
  const diffMs = now.getTime() - date.getTime();

  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

  if (isLoading) {
    return (
      <div className="learn-comment-section">
        <div className="learn-comment-skeleton">
          <div className="learn-skeleton-header"></div>
          <div className="learn-skeleton-form"></div>
          <div className="learn-skeleton-comment"></div>
          <div className="learn-skeleton-comment"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="learn-comment-section">
      <div className="learn-comment-header">
        <div className="learn-comment-title">
          <span className="learn-comment-icon">💬</span>
          <h3>Discussion</h3>
        </div>
        <span className="learn-comment-count">{comments.length} comments</span>
      </div>
      
<form onSubmit={handleSubmitComment} className="learn-comment-form">

  <div className="learn-comment-input-wrapper">

    <textarea
      placeholder={
     "Share your thoughts or ask a question..."
      }
      value={newComment}
      onChange={(e) => setNewComment(e.target.value)}
      rows="3"
      className="learn-comment-textarea"
      disabled={!loggedIn}
    />

    {!loggedIn && (
      <div className="learn-login-overlay">
      <span>
        🔒 Please{" "}
        <span onClick={handleLoginClick} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>
          login
        </span>{" "}
        to leave a comment
      </span>
      </div>
    )}

    <div className="learn-comment-form-footer">
      <div className="learn-comment-char-count">
        {newComment.length}/500
      </div>

      <button
        type="submit"
        disabled={
          !loggedIn ||
          isSubmitting ||
          !newComment.trim() ||
          newComment.length > 500
        }
        className="learn-submit-comment"
      >
        {isSubmitting ? (
          <span>⏳ Posting...</span>
        ) : (
          <span>✉️ Post Comment</span>
        )}
      </button>
    </div>

  </div>
</form>
      
      <div className="learn-comments-list">
        {comments.length === 0 ? (
          <div className="learn-no-comments">
            <span className="learn-no-comments-icon">💭</span>
            <p>No comments yet. Be the first to start the discussion!</p>
            <span className="learn-no-comments-hint">Share your knowledge or ask a question</span>
          </div>
        ) : (
          comments.map(comment => (
            <div key={comment.id} className="learn-comment-card">
              <div className="learn-comment-avatar">
                <span className="learn-avatar-initial">
                  {comment.author ? comment.author[0].toUpperCase() : 'U'}
                </span>
              </div>
              <div className="learn-comment-content">
                <div className="learn-comment-meta">
                  <span className="learn-comment-author">
                    {comment.author || 'Anonymous Learner'}
                  </span>
                  <span className="learn-comment-date">
                    {formatDate(comment.createdAt)}
                  </span>
                </div>
                <p className="learn-comment-text">{comment.content || comment.text}</p>
                {/* <div className="learn-comment-actions">
                  <button className="learn-comment-like">
                    <span>👍</span> Like
                  </button>
                  <button className="learn-comment-reply">
                    <span>💬</span> Reply
                  </button>
                </div> */}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CommentSection;